<script setup lang="ts">
/** PAGE CAGNOTTE — visionneuse plein écran des photos de la cagnotte. */
import { useRechercheHelpers } from "~/composables/useRechercheHelpers";

const props = defineProps<{ images: string[]; depart: number }>();
const emit = defineEmits<{ fermer: [] }>();
const { getImageUrl } = useRechercheHelpers();

const index = ref(props.depart);
const aller = (pas: number) => {
  index.value = (index.value + pas + props.images.length) % props.images.length;
};
function onKey(e: KeyboardEvent) {
  if (e.key === "Escape") emit("fermer");
  if (e.key === "ArrowRight") aller(1);
  if (e.key === "ArrowLeft") aller(-1);
}
onMounted(() => {
  window.addEventListener("keydown", onKey);
  document.body.style.overflow = "hidden";
});
onBeforeUnmount(() => {
  window.removeEventListener("keydown", onKey);
  document.body.style.overflow = "";
});
</script>

<template>
  <Teleport to="body">
    <div class="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center" @click.self="emit('fermer')">
      <button type="button" class="absolute top-5 right-5 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center" :aria-label="$t('commun.actions.fermer')" @click="emit('fermer')">
        <UIcon name="i-lucide-x" class="size-5" />
      </button>
      <p class="absolute top-7 left-1/2 -translate-x-1/2 text-white/70 text-sm">{{ index + 1 }} / {{ images.length }}</p>
      <button v-if="images.length > 1" type="button" class="absolute left-5 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center" :aria-label="$t('campagne.pageCagnotte.precedente')" @click="aller(-1)">
        <UIcon name="i-lucide-chevron-left" class="size-6" />
      </button>
      <img :key="images[index]" :src="getImageUrl(images[index] ?? null, undefined, 1800)" alt="" class="max-w-[88vw] max-h-[82vh] object-contain rounded-xl" />
      <button v-if="images.length > 1" type="button" class="absolute right-5 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center" :aria-label="$t('campagne.pageCagnotte.suivante')" @click="aller(1)">
        <UIcon name="i-lucide-chevron-right" class="size-6" />
      </button>
    </div>
  </Teleport>
</template>
